function noop() {
}

/**
 *
 * @param axiosClient
 * @param customOptions
 * @param customOptions.removeInterceptors
 * @param customOptions.interceptorShowSpinner
 * @param customOptions.interceptorHideSpinner
 * @param customOptions.onShowSpinner
 * @param customOptions.onHideSpinner
 * @return Array<requestI>
 */
export default function spinnerInterceptor(axiosClient, customOptions = {}) {
  const options = {
    onShowSpinner: noop,
    onHideSpinner: noop,
    interceptorShowSpinner,
    interceptorHideSpinner,
    interceptorErrorHideSpinner,
    ...customOptions
  };

  function removeInterceptors() {
    axiosClient.interceptors.request.eject(requestI);
    axiosClient.interceptors.response.eject(responseI);
  }

  function interceptorShowSpinner(config) {
    options.onShowSpinner();

    return config;
  }

  function interceptorHideSpinner(params) {
    options.onHideSpinner();

    return params;
  }

  function interceptorErrorHideSpinner(error) {
    options.onHideSpinner();

    return Promise.reject(error);
  }


  const requestI = axiosClient.interceptors.request.use(options.interceptorShowSpinner, options.interceptorErrorHideSpinner);
  const responseI = axiosClient.interceptors.response.use(options.interceptorHideSpinner, options.interceptorErrorHideSpinner);

  return removeInterceptors;
};
